import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { api } from "../utils/api";

const ROLES = ["admin", "user", "it_team", "it_manager", "it_security", "cfo"];
const PLANTS = ["TGS", "KASESE", "NAMANVE"];

export default function AdminPanel() {
  const [users, setUsers] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ username: "", email: "", full_name: "", password: "Pass@123", role: "user", plant: "TGS" });

  async function load() { const { data } = await api.get("/api/users"); setUsers(data); }
  useEffect(() => { load(); }, []);

  async function create(e) {
    e.preventDefault();
    try { await api.post("/api/auth/register", form); setShow(false); load(); }
    catch (ex) { alert(ex.response?.data?.detail || "Failed"); }
  }
  async function update(id, patch) { await api.put(`/api/users/${id}`, patch); load(); }
  async function remove(id) { if (window.confirm("Delete this user?")) { await api.delete(`/api/users/${id}`); load(); } }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Admin · User Management</h1>
        <button className="btn-primary flex items-center gap-2" onClick={() => setShow(true)}><Plus size={16} /> Create User</button>
      </div>

      <div className="card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600 text-left">
            <tr><th className="p-3">Username</th><th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Role</th><th className="p-3">Plant</th><th className="p-3">Active</th><th className="p-3"></th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t hover:bg-gray-50">
                <td className="p-3 font-mono">{u.username}</td>
                <td className="p-3">{u.full_name}</td>
                <td className="p-3">{u.email}</td>
                <td className="p-3">
                  <select className="input py-1 text-xs" value={u.role} onChange={(e) => update(u.id, { role: e.target.value })}>
                    {ROLES.map((r) => <option key={r}>{r}</option>)}
                  </select>
                </td>
                <td className="p-3">
                  <select className="input py-1 text-xs" value={u.plant || ""} onChange={(e) => update(u.id, { plant: e.target.value || null })}>
                    <option value="">—</option>
                    {PLANTS.map((p) => <option key={p}>{p}</option>)}
                  </select>
                </td>
                <td className="p-3">
                  <input type="checkbox" checked={u.is_active} onChange={(e) => update(u.id, { is_active: e.target.checked })} />
                </td>
                <td className="p-3"><button onClick={() => remove(u.id)} className="text-red-600 hover:text-red-800"><Trash2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {show && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <form onSubmit={create} className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="bg-brand-500 text-white px-5 py-3 rounded-t-lg font-semibold">Create User</div>
            <div className="p-5 space-y-3">
              <div><label className="label">Username</label><input className="input" required value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} /></div>
              <div><label className="label">Email</label><input className="input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
              <div><label className="label">Full name</label><input className="input" required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} /></div>
              <div><label className="label">Password</label><input className="input" type="text" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
              <div className="grid grid-cols-2 gap-3">
                <div><label className="label">Role</label><select className="input" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>{ROLES.map((r) => <option key={r}>{r}</option>)}</select></div>
                <div><label className="label">Plant</label><select className="input" value={form.plant} onChange={(e) => setForm({ ...form, plant: e.target.value })}>{PLANTS.map((p) => <option key={p}>{p}</option>)}</select></div>
              </div>
            </div>
            <div className="flex justify-end gap-2 px-5 py-3 bg-gray-50 rounded-b-lg">
              <button type="button" className="btn-secondary" onClick={() => setShow(false)}>Cancel</button>
              <button className="btn-primary">Create</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
